/*
(5.4.4) ##РЕАК ASSIGNMENTS= (STRING). List
of peak assignments for components or functional groups
in the forms ##РЕАК ASSIGNMENTS= (ХУА),
(XYW А), (ХУМА), (XYMW А). Each entry is surrounded Ьу parentheses and starts а new line. У, W (peak
width), and М (multiplicity) values are optional. The
symbol А stands for а string detailing the assignment
and must Ье enclosed Ьу angle brackets. If the peak width
value is included, then the function used to calculate the
peak width must Ье detailed in а $$ comment on the
line(s) below ##PEAKASSIGNMENTS=. Priority OPTIONAL. N.B.: ##РЕАК ASSIGNMENTS= is the preferred method of transmitting peak information when
the assignments are known.
 */
export default function parseXYA(spectrum, value) {
    spectrum.isXYAdata = true;
    const currentData = {};
    spectrum.data = currentData;
    let lines = value.split(/\r?\n/);
    const variables = lines[0]
        .replace(/^.*?([A-Z]+).*$/, '$1')
        .split('')
        .map((variable) => variable.toLowerCase());
    for (let i = 1; i < lines.length; i++) {
        const fields = lines[i].replace(/^\((.*)\)$/, '$1').split(/ *, */);
        for (let j = 0; j < variables.length; j++) {
            let value = fields[j];
            switch (variables[j]) {
                case 'x':
                case 'y':
                case 'w':
                    value = Number.parseFloat(value);
                    break;
                case 'a':
                    value = value.replace(/^<(.*)>$/, '$1');
                    break;
                case 'm':
                    break;
                default:
                    continue;
            }
            if (!currentData[variables[j]]) {
                currentData[variables[j]] = [];
            }
            currentData[variables[j]].push(value);
        }
    }
}
//# sourceMappingURL=parseXYA.js.map